/**
* @ngdoc service
* @name  sharebase.sbSharedContentService
* 
* @description 
* A service used to retrieve and interact with ShareBase
* libraries
* 
**/
export function SharedContentServiceFactory(
	$http:ng.IHttpService, 
	settingsService,
	pxPhoenixToggleService
) {
	return {
		/**
		* @ngdoc method
		* @name sbSharedContentService#getContent
		* @methodOf sharebase.sbSharedContentService
		* @kind function
		*
		* @description
		* Gets shared libraries, folders, and documents for a user
		* 
		* @returns {Deferred} A promise that will resolve with an
		* object of libraries, folders, and documents
		* 
		*/
		getContent
	};

	function getContent() {
		var shareObj = {
			libraries:[],
			folders:[],
			documents:[]
		};
		//TODO: remove the /home call when 'home-endpoint-v2' feature toggle is turned on
		return pxPhoenixToggleService.isEnabled('home-endpoint-v2')
			.then((isEnabled) => {
				if (isEnabled) {
					return $http.get<any>(settingsService.serverAPIPath + '/home-v2')
					.then(function (response) {
						shareObj.libraries = response.data.Embedded.Libraries;
						return $http.get<any>(settingsService.serverAPIPath + '/sharedfolders');
					})
					.then(function (response) {
						shareObj.folders = response.data;
						return $http.get<any>(settingsService.serverAPIPath + '/s');
					})
					.then(function(response){
						shareObj.documents = response.data;
						return shareObj;
					});
				}
				else {
					return $http.get<any>(settingsService.serverAPIPath + '/home')
					.then(function (response) {
						shareObj.libraries = response.data.Embedded.Libraries;
						shareObj.folders = response.data.Embedded.SharedFolders;
						return $http.get<any>(settingsService.serverAPIPath + '/s');
					})
					.then(function(response){
						shareObj.documents = response.data;
						return shareObj;
					});
				}
			});
	}
}

SharedContentServiceFactory.$inject = [
	'$http',
	'settingsService',
	'pxPhoenixToggleService'
];


// WEBPACK FOOTER //
// ./src/sharebase/services/sharedContentService.ts